export default "__VITE_ASSET__PouN8zmD__"